import { render, staticRenderFns } from "./BodySvgViewer.vue?vue&type=template&id=2b53f512&scoped=true"
import script from "./BodySvgViewer.vue?vue&type=script&lang=js"
export * from "./BodySvgViewer.vue?vue&type=script&lang=js"
import style0 from "./BodySvgViewer.vue?vue&type=style&index=0&id=2b53f512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b53f512",
  null
  
)

export default component.exports